// Default
import '../../custom/js/default';

// JS
// import '../../custom/js/index';

// Base SCSS
// import '../../custom/scss/style.scss';